// Pending two-factor sign-in, kept for this browser tab only.
//
// For accounts with two-factor login, the password step no longer returns an
// access token — it returns a short-lived "code pending" pass. The code screen
// sends that pass with the emailed code and receives the real token. Nothing
// is stored as the `token` cookie until then, so leaving the code screen
// cannot skip two-factor.

const STORAGE_KEY = "alpha-md:two-factor-pending";

/** account: "user" (physician/clinic) or "rep" */
export const savePendingSignIn = ({ pendingToken, email, account, userInvite }) => {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ pendingToken, email, account,
      ...(typeof userInvite === "string" && /^[a-f\d]{64}$/i.test(userInvite) ? { userInvite } : {}) }));
  } catch {
    // Storage unavailable (private mode etc.) — the code screen asks the user to log in again.
  }
};

export const readPendingSignIn = (account) => {
  try {
    const pending = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || "null");
    return pending && pending.account === account && pending.pendingToken ? pending : null;
  } catch {
    return null;
  }
};

export const clearPendingSignIn = () => {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
};
